<template>
  <div id="page_not_found">
    <div class="container">
      <h1 class="page-title">
        {{ $t("Something went wrong ...") }}
      </h1>
    </div>

    <div class="container">
      <div class="static-content">
        <p>
          {{ $t("We've noticed Internal Server Error while rendering this request.") }}
        </p>
        <p>
          {{ $t('If you need an assistance you can drop us a line on') }}:
          <a href="mailto:info@zaun24.de" class="cl-secondary no-underline">
            info@zaun24.de
          </a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Error from '@vue-storefront/core/pages/Error'

export default {
  name: 'Error',
  mixins: [Error]
}
</script>

<style scoped>
  a {
    text-decoration: underline;
  }
</style>
